import { orchestrator } from 'satcheljs';
import {
    availablePoliciesPageLoaded,
    onAvailableRetentionPoliciesListSucceeded,
    onAvailablePoliciesRequestSent,
    onAvailablePoliciesRequestError,
    onAvailablePoliciesRequestComplete,
} from '../actions/internalActions';
import getAvailablePolicies from '../services/getAvailablePolicies';
import extractRetentionPolicyInfo from '../helpers/extractRetentionPolicyInfo';
import { AvailableRetentionPolicyRowType } from '../store/schema/RetentionPolicyRowType';
import RetentionPolicyTagDisplay from 'owa-service/lib/contract/RetentionPolicyTagDisplay';
import { trace } from 'owa-trace';
import getAvailablePoliciesListState from '../selectors/getAvailablePoliciesListState';

/**
 * Orchestrator that get the list of available policies and sets the required data in store
 */
export default orchestrator(availablePoliciesPageLoaded, async () => {
    // Early return if we didn't make any change in the lists after last fetch
    if (!getAvailablePoliciesListState().isStale) {
        return;
    }
    onAvailablePoliciesRequestSent();
    try {
        const response = await getAvailablePolicies();

        if (!response.RetentionPolicyTagDisplayCollection) {
            throw new Error('Get available retention policies response is not valid');
        }
        const retentionPolicyTags =
            response.RetentionPolicyTagDisplayCollection.RetentionPolicyTags;

        const policiesMap: { [key: string]: AvailableRetentionPolicyRowType } = {};
        const policyRowIds: string[] = [];

        retentionPolicyTags.forEach((tag: RetentionPolicyTagDisplay) => {
            const refinedTag = extractRetentionPolicyInfo(tag) as AvailableRetentionPolicyRowType;
            const refinedTagId = refinedTag.RetentionId;
            policiesMap[refinedTagId] = refinedTag;
            policyRowIds.push(refinedTagId);
        });

        onAvailableRetentionPoliciesListSucceeded(policiesMap, policyRowIds);
    } catch (e) {
        trace.error(e);
        onAvailablePoliciesRequestError();
        return;
    }
    onAvailablePoliciesRequestComplete();
});
